<app-material>
    <div class="header" header>
        <h2>{{ 'admin.insertion-cycles.table.title' | translate }}</h2>
        <div class="mutators">
            <app-button *ngIf="hasEditPermissions"
                        (clicked)="openCreateInsertionCycleModal()">{{ 'admin.insertion-cycles.buttons.create' | translate }}
            </app-button>
        </div>
    </div>
    <ng-container body>
        <app-insertion-cycles-table [insertionCycles]="insertionCycles"
                                    [isLoading]="isLoadingInsertionCycles"
                                    [tableConfig]="tableConfig"
                                    [hasTitle]="false"
                                    [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                                    (filterChange)="onTableConfigChange()"
                                    (sortChange)="onTableConfigChange()"
                                    (rowClick)="onTableRowClick($event)"
                                    (pageChange)="onTableConfigChange()">
        </app-insertion-cycles-table>
    </ng-container>
</app-material>

<app-insertion-cycles-create-modal
    [isReadOnly]="!shouldRenderModifiers()"
    (onCreate)="create($event)"
    (onUpdate)="update($event)"
    (onDelete)="delete($event)"
    [isLoading]="isModalLoading"
    [insertionCycle]="selectedInsertionCycle"></app-insertion-cycles-create-modal>
